import {parseGPX, Track} from "@we-gold/gpxjs";

export const gpxRequest = async (gpx: string): Promise<Track | undefined | false> => {
  try {
    const init: RequestInit = {
      method: "GET"
    }
    return await fetch(gpx, init)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch the file")
        }
        return response.text()
      })
      .then((data) => {
        const [parsedFile, error] = parseGPX(data)
        if (error) throw error
        if (parsedFile?.tracks && parsedFile?.tracks.length > 0) {
          return parsedFile.tracks.pop()
        }
      })
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
}
